export const SAFE_AREA_INSET_TOP = 'env(safe-area-inset-top, 0)'
export const NEGATIVE_SAFE_AREA_INSET_TOP = `calc(-1 * ${SAFE_AREA_INSET_TOP})`
